const formatoArquivoEnum = {
  PDF: 'PDF',
  CSV: 'CSV'
};

export default formatoArquivoEnum;
